import { Button, Stack } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardActivityRow } from "web_myplann/Dashboard/Components/DashboardActivityRow";
import { DashboardSection } from "web_myplann/Dashboard/Components/DashboardSection";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { DashboardTaskRow } from "web_myplann/Dashboard/Components/DashboardTaskRow";
import { useDashboardActivities } from "web_myplann/Dashboard/Hooks/useDashboardActivities";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const SECTION_PREVIEW_SIZE = 2;
const R = Resources.Dashboard.Sections;

export const DashboardActivitySections: FC = () => {
	const { t } = useResource();
	const navigate = useNavigate();

	const { solvedEvents, upcomingEvents, overdueEvents, isLoading } =
		useDashboardActivities(SECTION_PREVIEW_SIZE);

	if (isLoading) {
		return (
			<Stack px={1.6}>
				<DashboardSkeleton height={150} />
			</Stack>
		);
	}

	const showAll = () => navigate(Routing.ActivitiesList.path());

	const visibleTasks = solvedEvents.items;
	const visibleUpcoming = upcomingEvents.items;
	const visiblePast = overdueEvents.items;

	return (
		<>
			{visibleTasks.length > 0 && (
				<DashboardSection title={t(R.todo)}>
					{visibleTasks.map((task, index) => (
						<DashboardTaskRow
							key={task.id}
							data={task}
							showDivider={index < visibleTasks.length - 1}
						/>
					))}
					<Button variant="showAll" onClick={showAll}>
						{t(Resources.Dashboard.ShowAllButton.title)} →
					</Button>
				</DashboardSection>
			)}

			{visibleUpcoming.length > 0 && (
				<DashboardSection title={t(R.upcoming)}>
					{visibleUpcoming.map((event, index) => (
						<DashboardActivityRow
							key={event.id}
							data={event}
							showDivider={index < visibleUpcoming.length - 1}
						/>
					))}
					<Button variant="showAll" onClick={showAll}>
						{t(Resources.Dashboard.ShowAllButton.title)} →
					</Button>
				</DashboardSection>
			)}

			{visiblePast.length > 0 && (
				<DashboardSection title={t(R.past)}>
					{visiblePast.map((event, index) => (
						<DashboardActivityRow
							key={event.id}
							data={event}
							showDivider={index < visiblePast.length - 1}
						/>
					))}
					<Button variant="showAll" onClick={showAll}>
						{t(Resources.Dashboard.ShowAllButton.title)} →
					</Button>
				</DashboardSection>
			)}
		</>
	);
};
